/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&name=Device&setup=true&lang=js"
export * from "./index.vue?vue&type=script&name=Device&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1888099a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1888099a"]])

export default __exports__